export interface Global {
    isLoading: boolean;
}

export function getInitialState(): Global {
    return {
        isLoading: false,
    };
}
